/** Split total stake across N legs (cent-accurate); mirrors Next.js retail slip logic */
export function splitStakeTotal(total: number, n: number): number[] {
  if (n < 1) return [];
  const cents = Math.round(total * 100);
  const base = Math.floor(cents / n);
  const remainder = cents - base * n;
  return Array.from({ length: n }, (_, i) => (base + (i < remainder ? 1 : 0)) / 100);
}
